import PaginationView from './pagination-view'

export default PaginationView
